import "./ShowUserOnboardingProgress.css";

import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";

export const ShowUserOnboardingProgressPage = () => {
  const { state } = useLocation();

  const data = state?.data;

  return (
    <>
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: (
                <Link to="/user-onboarding-progress">
                  User Onboarding Progress
                </Link>
              ),
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{data?.id}</p>
          </div>
          <div className="row">
            <p className="label">User Id</p>
            <p className="value">{data?.userId}</p>
          </div>
          <div className="row">
            <p className="label">Progress</p>
            <div className="tagBox"></div>
          </div>
          <div className="row">
            <p className="label">Current Step Key</p>
            <p className="value">{data?.currentStepKey}</p>
          </div>
          <div className="row">
            <p className="label">Started At</p>
            <p className="value">{data?.startedAt}</p>
          </div>
          <div className="row">
            <p className="label">Last Updated At</p>
            <p className="value">{data?.lastUpdatedAt}</p>
          </div>
          <div className="row">
            <p className="label">Completed At</p>
            <p className="value">{data?.completedAt}</p>
          </div>
        </div>
      </div>
    </>
  );
};
